function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Spin, Select, Divider, Space } from "antd";
import { Eyedropper } from 'react-bootstrap-icons';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var LaboForm = function LaboForm(_ref) {
  var handler = _ref.handler,
    customer = _ref.customer;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    successMessage = _useState4[0],
    setSuccessMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setSuccessMessage('');
    setErrorMessage('');
    axios.post(Common.baseApiUrl + 'setlaboresult', {
      group: values.group,
      rhesus: values.rhesus,
      user_id: Common.currentUser.id,
      customer_id: customer.id.toString()
    }).then(function (response) {
      setIsFormProcessing(false);
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormProcessing(false);
      setErrorMessage('Une erreur est survenue');
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      group: 'A',
      rhesus: '+'
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "cool-radius",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
        children: [/*#__PURE__*/_jsx(Eyedropper, {
          size: 30
        }), "LABORATOIRE"]
      }), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "success",
        message: successMessage
      }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: errorMessage
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Form, {
        form: form,
        onFinish: onFinish,
        layout: "horizontal",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "group",
          label: "Groupe Sanguin",
          rules: [{
            required: true,
            message: ' Veuillez remplir le groupe sanguin'
          }],
          children: /*#__PURE__*/_jsxs(Select, {
            children: [/*#__PURE__*/_jsx(Option, {
              value: "A",
              children: "A"
            }), /*#__PURE__*/_jsx(Option, {
              value: "B",
              children: "B"
            }), /*#__PURE__*/_jsx(Option, {
              value: "AB",
              children: "AB"
            }), /*#__PURE__*/_jsx(Option, {
              value: "O",
              children: "O"
            })]
          })
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "rhesus",
          label: "Facteur rh\xE9sus",
          rules: [{
            required: true,
            message: ' Veuillez remplir le facteur rhesus'
          }],
          children: /*#__PURE__*/_jsxs(Select, {
            children: [/*#__PURE__*/_jsx(Option, {
              value: "+",
              children: "Positif"
            }), /*#__PURE__*/_jsx(Option, {
              value: "-",
              children: "N\xE9gatif"
            })]
          })
        }), /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Form.Item, {
            children: /*#__PURE__*/_jsx(Button, {
              type: "primary",
              htmlType: "submit",
              children: "Envoyer"
            })
          }), isFormProcessing && /*#__PURE__*/_jsx(Spin, {})]
        })]
      })]
    })
  });
};
export default LaboForm;